const baseTypo = {
  fontFamily: 'Inter',
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '148%',
};

export const styles = {
  typo: (expanded: boolean) => ({
    display: '-webkit-box',
    WebkitLineClamp: expanded ? 'none' : 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    '& p, a': {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400,
      margin: '0',
      color: '#23252F',
      wordBreak: 'break-word',
      minHeight: '20px',
    },
    '& p': {
      margin: 0,
      color: '#424550',
      ...baseTypo,
    },
    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#4D6EF5',
    },
  }),
  button: {
    p: 0,
    minWidth: 'unset',
    color: '#4D6EF5',
    textTransform: 'none',
    ...baseTypo,
  },
};
